// import-sort-ignore

import EntityActionTypes from './EntityActionTypes';
import reducer from './reducer';

// Entity plugin
export default {
  reducers: {
    entities: reducer,
  },
  actionTypes: EntityActionTypes,
};

import * as EntityActions from './EntityActions';
export { EntityActions };

export { default as EntityActionTypes } from './EntityActionTypes';

import * as entityStatuses from './utils/statuses';
export { entityStatuses };

import * as entityUtils from './utils/entityUtils';
export { entityUtils };

export { default as buildEntityActions } from './utils/buildEntityActions';
export { default as buildEntityApi } from './utils/buildEntityApi';
export {
  default as buildEntitySelectors,
  createEntitySelector,
} from './utils/buildEntitySelectors';

// This is the only `normalizeXError` method that needs to be consumed externally right now.
export { normalizePostError } from './utils/normalizeFetchError';
